<template>
  <div>
    <RevokeTask :operRole="2" />
  </div>
</template>
<script>
import RevokeTask from '@/components/workOrder/common/RevokeTask.vue'
export default {
  components: {
    RevokeTask
  }
}
</script>
